import { ApiBase } from "~/extensions/api";
import { FindRsyncCommand } from "./commands/FindRsyncCommand";
import { RsyncCommand } from "./commands/RsyncCommand";
export class RsyncApi extends ApiBase {
    /**検索API */
    find(model, pagination) {
        let command = new FindRsyncCommand(model);
        pagination.applyTo(command);
        return this.request(command);
    }
    /**再同期API */
    rsync(model) {
        let command = new RsyncCommand(model);
        return this.request(command);
    }
}
